import { Fragment } from "react";
import CircularProgress from '@mui/material/CircularProgress';

import useFetch from "../../../hooks/useFetch";
import { urlProduct } from "../../../helpers";
import { ProductsScreen } from "../ProductsScreen";
import { Stack } from "@mui/material";
import { TitlePage } from "../../../components/TitlePage";

export const GetProduct = ({type}) => {

    const { data, status } = useFetch(urlProduct);

    return (
        <Stack width='100%' alignItems='center' mt='2rem'>
            <Stack width='95%'>
                <TitlePage title='Productos' subtitle={subtitle} buttonTitle={buttonTitle} />
                <Fragment>
                    {status
                        ? <ProductsScreen data={data} type={type}/>
                        : <Stack alignItems='center' mt={10}><CircularProgress /></Stack>
                    }
                </Fragment>
            </Stack>
        </Stack>
    )
}

const subtitle = 'Consultar productos';
const buttonTitle = 'Añadir producto';